module.exports = __webpack_public_path__ + "img/img_inner_pastel.a29686fc.png";